export class LandingController {
    constructor(flowService, $stateParams, destinationService) {
        if(!$stateParams.worker){
            destinationService.clear();
        }
        flowService.initFlow($stateParams.worker, $stateParams.destinationResource, $stateParams.nspIdCardRequired, $stateParams.securityContext, $stateParams.installationUserId);
    }
}

LandingController.$inject = ['flowService', '$stateParams', 'destinationService'];
